module.exports = __webpack_public_path__ + "img/BlueberryEater.7cc420d9.png";